import React from 'react';
import Wallets from './Wallets';

const WithdrawCrypto = () => {
  return <Wallets />;
};

export default WithdrawCrypto;